// extracted by mini-css-extract-plugin
export default {"box":"errorPage_box__lZGmM","msgBox":"errorPage_msgBox__WRkoK","msgBox__msg":"errorPage_msgBox__msg__UIxQD","btn":"errorPage_btn__b7KnK"};